import headers from './headers';
import { handleResponse, handleError } from './fetchHelper';

const Verbs = {
    Get: 'GET',
    Post: 'POST',
    Put: 'PUT',
    Delete: 'DELETE',
    Head: 'HEAD',
};

const httpCall = async (verb, url, body = '', otherHeaders = {}) => {

    const options = {
        method: verb,
        headers: {
            ...headers(otherHeaders)
        }
    };

    if (verb === Verbs.Put || verb === Verbs.Post) {
        options.body = JSON.stringify(body);
    }

    return fetch(url, options)
        .then(handleResponse)
        .catch(handleError);
};

export default {
    /**
     * Gets a JSON serialized response from the given endpoint URL
     * @param url The URL to GET from
     * @param otherHeaders Optional headers to add to the request
     */
    get: (url, otherHeaders = {}) => httpCall(Verbs.Get, url, otherHeaders),

    /**
     * Posts the contents of the body as a JSON serialized string to the endpoint URL
     * @param url The URL to POST to
     * @param body The body to send
     * @param otherHeaders Optional headers to add to the request
     */
    post: (url, body, otherHeaders = {}) => httpCall(Verbs.Post, url, body, otherHeaders),

    /**
     * Puts the contents of the body as a JSON serialized string to the endpoint URL
     * @param url The URL to PUT to
     * @param body The body to send
     */
    put: (url, body, otherHeaders = {}) => httpCall(Verbs.Put, url, body, otherHeaders),

    /**
     * Deletes the resource at the endpoint URL
     * @param url The URL to DELETE
     */
    delete: (url, otherHeaders = {}) => httpCall(Verbs.Delete, url, '', otherHeaders)
};
